import { render, staticRenderFns } from "./AgentColorModal.vue?vue&type=template&id=218d6854&"
import script from "./AgentColorModal.vue?vue&type=script&lang=js&"
export * from "./AgentColorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('218d6854')) {
      api.createRecord('218d6854', component.options)
    } else {
      api.reload('218d6854', component.options)
    }
    module.hot.accept("./AgentColorModal.vue?vue&type=template&id=218d6854&", function () {
      api.rerender('218d6854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/calendar/AgentColorModal.vue"
export default component.exports